// Story 18.19 (ADO-4086), AC11: the "RBP Shopping List" action in the header bars, beside "HHT
// Orders" (SL1.0 `choose.htm:23` puts it beside the HHT button). One markup for `SiteHeader` and
// the app's chooser header; each host passes the route and its own classes, so the link sits in
// its bar's layout as `HhtOrdersLink` does. The host decides whether to draw it (server-derived
// eligibility); the design system only draws it. The check mark is the action's existing mark;
// the name stays on the link where a phone bar hides the label.
import { Link } from 'react-router';
import { Icon } from '../Icon/Icon';

export const RBP_SHOPPING_LIST_LABEL = 'RBP Shopping List';

/** CSS module class names (a module lookup is typed `string | undefined`). */
export interface RbpShoppingListLinkClasses {
  readonly link: string | undefined;
  readonly label: string | undefined;
}

export function RbpShoppingListLink({
  to,
  classes,
}: {
  readonly to: string;
  readonly classes: RbpShoppingListLinkClasses;
}) {
  return (
    <Link to={to} className={classes.link} aria-label={RBP_SHOPPING_LIST_LABEL}>
      <Icon name="checkCircle" size={18} />
      <span className={classes.label}>{RBP_SHOPPING_LIST_LABEL}</span>
    </Link>
  );
}
